// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Hero_wrapper_1mInl","inner":"Hero_inner_lT3a6","title":"Hero_title_2CrFB","big":"Hero_big_VTZX6","list":"Hero_list_1VXEC","share":"Hero_share_3v3QH"};